import { useState } from "react";
import BottomSheet from "../../../components/common/bottom-sheet";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import FadeInWrapper from "../../../components/common/fade-in-wrapper";
import MISSION1_IMG from "../assets/sheet-image/mission1.png";
import PERSON_WHO_EAT_IMG from "../assets/sheet-image/personwhoeat.png";
import PAYBACK_IMG from "../assets/sheet-image/payback.png";

interface ParticipationGuideSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const ParticipationGuideSheet = ({
  isOpen,
  onClose,
}: ParticipationGuideSheetProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      buttonText="확인"
      onButtonClick={onClose}
    >
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        onSlideChange={(swiper: any) => setCurrentSlide(swiper.activeIndex)}
        className="max-w-[742px]"
      >
        <SwiperSlide>
          <div className="flex flex-col h-full">
            <FadeInWrapper className="flex items-start mb-3">
              <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                1
              </div>
              <div className="flex-1">
                <h1 className="text-xl font-bold">미션에 참여해요!</h1>
                <p className="text-sm text-gray-600 mt-1">
                  원하는 음식점을 골라 미션에 참여해요!
                </p>
              </div>
            </FadeInWrapper>
            <div className="flex justify-center items-center flex-1 min-h-0">
              <img
                src={MISSION1_IMG}
                alt="미션 참여"
                className="h-full max-h-40 object-contain rounded-lg"
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="flex flex-col h-full">
            <FadeInWrapper className="flex items-start mb-3">
              <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                2
              </div>
              <div className="flex-1">
                <h1 className="text-xl font-bold">음식점에서 식사를 해요!</h1>
                <p className="text-sm text-gray-600 mt-1">
                  실제 예약을 마친뒤 매장 내에서 식사를 해요
                </p>
              </div>
            </FadeInWrapper>
            <div className="flex justify-center items-center flex-1 min-h-0">
              <img
                src={PERSON_WHO_EAT_IMG}
                alt="식사"
                className="h-full max-h-40 object-contain rounded-lg"
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="flex flex-col h-full">
            <FadeInWrapper className="flex items-start mb-3">
              <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2 flex-shrink-0">
                3
              </div>
              <div className="flex-1">
                <h1 className="text-xl font-bold">
                  미션을 완료하고 <br />
                  50-80% 할인을 받아요 ~
                </h1>
                <p className="text-sm text-gray-600 mt-1">
                  정해진 미션완수를 통해 페이백을 받아요 😁
                </p>
              </div>
            </FadeInWrapper>
            <div className="flex justify-center items-center flex-1 min-h-0">
              <img
                src={PAYBACK_IMG}
                alt="페이백"
                className="h-full max-h-40 object-contain rounded-lg"
              />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      {/* 수동 페이지네이션 점 */}
      <div className="flex justify-center mt-4">
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            className={`w-3 h-3 mx-1 rounded-full ${
              currentSlide === index ? "bg-blue-500" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </BottomSheet>
  );
};

export default ParticipationGuideSheet;
